import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { Storage } from '@ionic/storage';
import { NavController, Platform } from '@ionic/angular';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  login_status:boolean=false;
  permissions:any=[];

  authStatus = new BehaviorSubject(false);
  constructor(private platform: Platform,private router: Router,
    private storage: Storage, private navcontroller: NavController) {
      this.platform.ready().then(()=>{
        this.initialize();
      })
     }
     canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<any> | Promise<any> {
      return new Promise<any>((resolve) => {
        resolve(this.login_status);
     });
    }
    getAuthStatus(){
      return this.authStatus.asObservable();
    }
     initialize(){
      this.storage.get(environment.storagekeys.islogin).then( data => {
        this.login_status= data;
        console.log(data, this.login_status);
        if(!this.login_status){
          this.navcontroller.navigateRoot(['/login']);
          this.authStatus.next(false);
        }else{
          this.storage.get(environment.storagekeys.loginDetails).then( data => {
            if(data!==null){
              this.permissions= data.permissions;
              this.authStatus.next(true);
              console.log(this.permissions);
              if(data.role ==="Driver"){
                if(this.router.url==='/login'||this.router.url==='/')
                this.navcontroller.navigateRoot(['/app/production/beater-buster']);
              }
              else{
                if(environment.isProduction){
                  if(this.router.url==='/login'||this.router.url==='/')
                  this.navcontroller.navigateRoot(['/app/dashboard']);
                }else{

                  if(this.router.url==='/login')
                  // if(this.router.url==='/login'||this.router.url==='/')
                  this.navcontroller.navigateRoot(['/app/dashboard']);
                }
              }
            }
          })
        }
      });
    }
    setLoginStatus(setloginstatus:boolean=false, loginDetails:any={}){
      this.storage.set(environment.storagekeys.islogin,setloginstatus).then(s=>console.log(s));
      this.login_status = setloginstatus;
      this.storage.set(environment.storagekeys.loginDetails,loginDetails).then(s=>console.log(s));
      this.permissions = loginDetails.permissions;
    }
    checkAccess(module,action=null){
      if(action===null)
        return (this.permissions[module])
      if(!this.permissions[module])
        return false;
      return (this.permissions[module].includes(action))
    }
    checkModuleAction(module,action){
      if(!this.permissions[module])
        return false;
      return (this.permissions[module].includes(action))
    }
    getModulePermission(module){
      if(!this.permissions[module])
        return [];
      return this.permissions[module];
    }
}
